import { render } from "./DataFieldComponent.vue?vue&type=template&id=50201d56&scoped=true"
import script from "./DataFieldComponent.vue?vue&type=script&lang=js"
export * from "./DataFieldComponent.vue?vue&type=script&lang=js"

import "./DataFieldComponent.vue?vue&type=style&index=0&id=50201d56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50201d56"]])

export default __exports__